import * as XLSX from "xlsx";
import FileSaver from "file-saver";
let publicFun = {
    data() {
        return {
            userDict:[],
            myManageUserDict:[],
            purviewAdd:false,
            purviewEdit:false,
            purviewDel:false,
            purviewAudit:false,
            purviewImport:false,
            purviewExport:false,
            unitNameDict: [],
            brandIdDict: [],
            inTypeDict:[],
            outTypeDict:[],
			companyTypeDict:[{label:'供应商',value:1},{label:'客户',value:2}],
            storeHouseDict:[],
            clueStatusDict:[{label:'未处理',value:0},{label:'已处理',value:1},{label:'已忽略',value:2}],
            urgencyTypeDict:[{label:'较低',value:0},{label:'一般',value:1},{label:'紧急',value:2}],
            invoiceTypeDict:[{label:'普票',value:0},{label:'增值发票',value:1}],
            checkTypeDict:[],
            nativePlaceDict:["汉族","蒙古族","回族","藏族","维吾尔族","苗族","彝族","壮族","布依族","朝鲜族","满族","侗族","瑶族","白族","土家族","哈尼族","哈萨克族","傣族","黎族","傈僳族","佤族","畲族","高山族","拉祜族","水族","东乡族","纳西族","景颇族","柯尔克孜族","达斡尔族","仫佬族","羌族","布朗族","撒拉族","毛南族","仡佬族","锡伯族","阿昌族","普米族","塔吉克族","怒族","乌孜别克族","俄罗斯族","鄂温克族","德昂族","保安族","裕固族","京族","塔塔尔族","独龙族","鄂伦春族","赫哲族","门巴族和基诺族"],
            sexTypeDict:["男士","女士"],
            maritalStatusDict:["未婚","已婚"],
            empTypeDict:[{label:'正式员工',value:0},{label:'外包员工',value:1}],
            workStatusDict:[{label:'在职',value:0},{label:'离职',value:1}],
            postTypeDict:[],
            degreeTypeDict:[],
            leaveTypeDict:[],
            empContractTypeDict:[{label:'试用',value:0},{label:'固定期限',value:1},{label:'无固定期限',value:2}],
            auditStatusDict:[{label:'待审批',value:0},{label:'审批通过',value:1},{label:'审批未通过',value:2}],
            holidayTypeDict:[{label:'休息',value:7},{label:'元旦',value:0},{label:'春节',value:1},{label:'清明',value:2},{label:'五一',value:3},{label:'端午',value:4},{label:'中秋',value:5},{label:'国庆',value:6}],
            lvtagColors: [{ color: '#fff', bgColor: '#129B11' }, { color: '#fff', bgColor: '#ff0000' }, { color: '#000', bgColor: '#ffcc33' }, { color: '#FFFFFF', bgColor: '#2EEDD3' }, { color: '#FFFFFF', bgColor: '#CC2742' }],
            lvGradeTypeDict:[],
            lvStatusDict:[{label:'下架',value:0},{label:'上架',value:1}],
            userTypeDict:[{label:'试用',value:0},{label:'付费',value:1}],
            proStatusDict:[{label:'停用',value:0},{label:'正常',value:1}],
            lvUserStatusDict:[{label:'禁用',value:0},{label:'正常',value:1}],
        }
    },
    methods: {
        showMsg: function (msg) {
            this.$message({
                message: msg,
                type: 'success'
            });
        },
        showErrMsg: function (msg) {
            this.$message({
                message: msg,
                type: 'error'
            });
        },
           // type 0 第一天; 1 最后一天; 不传 当天;
      getDefaultDay(type = 2) {
        let date = new Date;
        let y = date.getFullYear().toString();
        let m = (date.getMonth() + 1).toString().padStart(2, 0);
        let d = (['1', new Date(y, m, 0).getDate(), date.getDate()][type]).toString().padStart(2, 0);
        return [y, m, d].join("-");
      },
      getMonthReduce(monthNum) {
        let lastDate = new Date().setMonth(new Date().getMonth() - monthNum); // 输出日期格式为毫秒形式1551398400000
        lastDate = new Date(lastDate);
        let lastYear = lastDate.getFullYear();
        let lastMonth = (lastDate.getMonth() + 1).toString().padStart(2, 0); // 因日期中的月份表示为0-11，所以要显示正确的月份，需要 + 1
        lastDate = lastYear + "-" + lastMonth; 
        return lastDate
      },
        isNumber(str){
            return !isNaN(str)
        },
        getUserName(){
            return localStorage.getItem("userName")
        },
        getLogName(){
            return localStorage.getItem("logName")
        },
        handlePrice(key, row) {
            let value = row[key].replace(/\D*(\d*)(\.?)(\d{0,2})\d*/,'$1$2$3') // 只能输入数字、小数点限制2位; // 只能输入数字
            value = value.replace(/^0+(\d)/, "$1"); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
            value = value.replace(/^\./, '0.') // 最多保留15位整数
            if (value == "") value = "0"
            row[key] = value
        },
        handleNum(key, row) {
            let value = row[key].replace(/[^\d]/g, ""); // 只能输入数字
            value = value.replace(/^0+(\d)/, "$1"); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
            value = value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
            if (value == "") value = "0"
            row[key] = value
        },
        // 合并单元格
        publicObjectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.column) {
                let keyData = Object.keys(row.column);
                let index = keyData.indexOf(column.property);

                if (index == -1) {
                    if (row.merge) {
                        return {
                            rowspan: row[this.detailListKey].length,
                            colspan: 1,
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0,
                        };
                    }
                }
            }
        },
        checkUploadPic(file) {
            var img = file.name.substring(file.name.lastIndexOf('.') + 1)
            const suffix = img === 'jpg'
            const suffix2 = img === 'png'
            const suffix3 = img === 'jpeg'
            const isLt1M = file.size / 1024 / 1024 < 5;
            if (!suffix && !suffix2 && !suffix3) {
                this.showErrMsg("只能上传图片jpg,png,jpeg！");
                return false
            }
            if (!isLt1M) {
                this.showErrMsg('上传图片大小不能超过 5MB!');
                return file;
            }
            return true;
        },
        handleSizeChange(val) {
			this.filters.rows = val;
			this.getGridData();
		},
		handleCurrentChange(val) {
			this.filters.page = val;
			this.getGridData();
		},
        showAuditStatus(row){
			let idx=this.auditStatusDict.findIndex(v=>v.value==row.auditStatus)
			if(idx!=-1){
				let html = this.auditStatusDict[idx].label
				if (row.auditStatus == 0) html = "<font color='#FF9900'>●</font>"+html
				else if (row.auditStatus == 1) html = "<font color='#19BE6B'>●</font>"+html
				else html="<font color='#ccc'>●</font>"+html
				return html
			}
			else return "";
		},
        async getDictInfo(keyId) {
            let formData = this.$util.jsonToForm({
                keyId: keyId,
                rows: 10000,
                page: 1
            });
            let result = await this.$axios.post("/basic/getsysdictionarylist", formData)
            let dict = JSON.parse(JSON.stringify(result.data.data))
            dict.map((item) => {
                this.$set(item, "textkey", item.keyName)
                this.$set(item, "valuekey",this.isNumber(item.keyValue)?Number(item.keyValue):item.keyValue)
            })
            return dict
        },
        async getUnitName() {
            this.unitNameDict=JSON.parse(JSON.stringify(await this.getDictInfo('unitType')))
        },
        async getInTypeDict() {
            this.inTypeDict=JSON.parse(JSON.stringify(await this.getDictInfo('inType')))
        },
        async getOutTypeDict() {
            this.outTypeDict= JSON.parse(JSON.stringify(await this.getDictInfo('outType')))
        },
        async getCheckTypeDict() {
            this.checkTypeDict=JSON.parse(JSON.stringify(await this.getDictInfo('checkType')))
        },
        async getPostTypeDict() {
            this.postTypeDict=JSON.parse(JSON.stringify(await this.getDictInfo('postType')))
        },
        async getDegreeTypeDict() {
            this.degreeTypeDict=JSON.parse(JSON.stringify(await this.getDictInfo('degreeType')))
        },
        async getLeaveTypeDict() {
            this.leaveTypeDict=JSON.parse(JSON.stringify(await this.getDictInfo('leaveType')))
        },
        async getBrandData() {
            let formData = this.$util.jsonToForm({ brandName: "", rows: 1000, page: 1 });
            let result = await this.$axios.post("/product/getbasic_productbrandlist", formData)
            this.brandIdDict = JSON.parse(JSON.stringify(result.data.data))
            this.brandIdDict.map(item => {
                this.$set(item, "textkey", item.brandName)
                this.$set(item, "valuekey", item.id)
            })
        },
        async getStoreHouseData() {
            let formData = this.$util.jsonToForm({ storeName: "", rows: 1000, page: 1 });
            let result = await this.$axios.post("/basic/getstorehouselist", formData)
            this.storeHouseDict = JSON.parse(JSON.stringify(result.data.data))
            this.storeHouseDict.map(item => {
                this.$set(item, "textkey", item.storeName)
                this.$set(item, "valuekey", item.id)
            })
        },
        async getMyManageUserData() {
            let formData = new FormData()
            let result = await this.$axios.get("/backadmin/getmymanageuserlist",formData)
            this.myManageUserDict = JSON.parse(JSON.stringify(result.data.data))
            this.myManageUserDict.map(item => {
                this.$set(item, "textkey", item.adminName)
                this.$set(item, "valuekey", item.adminAccount)
            })
        },
        async getUserData() {
            let formData = this.$util.jsonToForm({
                adminName: '',
                isSuperAdmin:0,
                rows:1000,
                page:1,
            });
            let result = await this.$axios.post("/backadmin/geteslrecordlist",formData)
            this.userDict = JSON.parse(JSON.stringify(result.data.data))
            this.userDict.map(item => {
                this.$set(item, "textkey", item.adminName)
                this.$set(item, "valuekey", item.adminAccount)
            })
        },
        async getNewNumber(keyCode) {
            let formData = this.$util.jsonToForm({ keyCode: keyCode });
            let result = await this.$axios.post("/basic/getnewnumber", formData)
            return result.data.data;
        },
        async getPageFuncodes(purviewCode) {
            let childCodes=localStorage.getItem("childCodes") || ""
            if(childCodes=="000"){
                this.purviewAdd=true
                this.purviewEdit=true
                this.purviewDel=true
                this.purviewAudit=true
                this.purviewImport=true
                this.purviewExport=true
            }
            else{
                let codes=","+childCodes+","
                this.purviewAdd=(codes.indexOf(','+purviewCode+'_1,')!=-1)
                this.purviewEdit=(codes.indexOf(','+purviewCode+'_2,')!=-1)
                this.purviewDel=(codes.indexOf(','+purviewCode+'_3,')!=-1)
                this.purviewAudit=(codes.indexOf(','+purviewCode+'_4,')!=-1)
                this.purviewImport=(codes.indexOf(','+purviewCode+'_5,')!=-1)
                this.purviewExport=(codes.indexOf(','+purviewCode+'_6,')!=-1)
            }
        },
        async getSchoolDict() {
			let formData = this.$util.jsonToForm({
				schoolName: '',
                logName:'',
                teamPerson:'',
                linkTel:'',
                status:'',
				rows: 1000,
				page: 1});
		   let dict=(await this.$axios.post("/school/getschoolinfolist", formData)).data.data
           dict.map(item => {
                this.$set(item, "textkey", item.schoolName)
                this.$set(item, "valuekey", item.id)
            })
            return dict;
		},
        async getTeacherDict(schoolId) {
			let formData = this.$util.jsonToForm({
				schoolId: schoolId!==null?schoolId:'',
                teacherName:'',
                linkTel:'',
				rows: 1000,
				page: 1});
		   let dict=(await this.$axios.post("/school/getteacherinfolist", formData)).data.data
           dict.map(item => {
            if(item.status==1){
                this.$set(item, "textkey", item.teacherName+"("+item.schoolName+")")
            }
            else{
                this.$set(item, "textkey", item.teacherName+"(离职)")
            }

                this.$set(item, "valuekey", item.id)
            })
            return dict;
		},
        async loadGrade() {
			let formData = this.$util.jsonToForm({
				rows: 1000,
				page: 1
			});
            let dict=(await this.$axios.post("/basic/getgradeinfolist", formData)).data.data
           dict.map(item => {
                this.$set(item, "textkey", item.gradeName)
                this.$set(item, "valuekey", item.id)
            })
            return dict;
		},
        async getExerciseGroupTreeData(fromType){
            let formData = this.$util.jsonToForm({
				id: 0,
				parentId: 0,
				sortNum: 0,
				"isDrag": 0,
				fromType:fromType
			});
            let data=(await this.$axios.post("/exercise/getexercisegrouplist", formData)).data.data
			return data
        },
        async uploadOssFile(file){
            let policyData = (await this.$axios.get("/comm/getOssPolicy?rnd=" + new Date().getTime())).data.data;
            const formData = new FormData();
            formData.append('key', policyData.newFileName + "." + file.name.split('.').pop()); // 上传到OSS的文件路径和名称
            formData.append('OSSAccessKeyId', policyData.accessId);
            formData.append('policy', policyData.policy);
            formData.append('signature', policyData.signature);
            formData.append('file', file);
            formData.append('success_action_status',200)
            let res=(await this.$axios.post(policyData.host, formData))
            if(res.status=='200'){
                return [formData.get("key"),policyData.host + "/" + formData.get("key")]
            }
            else{
                return null
            }
        },
        async getLatLng(addr){
            let data = (await this.$axios.get("/comm/getLatLng?rnd=" + new Date().getTime()+"&addr="+addr)).data
            if(data.status==0){
                return data.data.split(',')
            }
            else{
                this.showErrMsg("获取坐标失败！");
                return null
            }
        },
           // 导出
    publicHandleExport(id, subName) {
        try {
          const $e = this.$refs[id].$el.cloneNode(true);
          let $table = $e.querySelector(".el-table__fixed");
          let isFix=$table!=undefined
  
          
          if (!$table) {
            $table = $e;
          }
  
          //删除列配置相关表格
          let tableHeader = $table.querySelector(isFix?'.el-table__fixed-header-wrapper':'.el-table__header-wrapper');
          let headerDom = tableHeader.childNodes[0].querySelectorAll('table thead th');
          let isExists=false
  
          // for(let k=0;k<headerDom.length;k++){
          //   if (!isExists && headerDom[k].innerText.indexOf("序")!=-1) {
          //     let col=headerDom[k].querySelectorAll('.popoverColumn')
          //     if(col!=undefined && col.length>0){
          //       col[0].remove();
          //     }
          //     isExists=true;
          //   }
          // }
          for (let key in headerDom) {
              if(headerDom[key].innerText){
                  if (!isExists && headerDom[key].innerText.indexOf("序")!=-1) {
                    let col=headerDom[key].querySelectorAll('.popoverColumn')
                    if(col!=undefined && col.length>0){
                      col[0].remove();
                    }
                    isExists=true;
                  }
              }
          }
          const wb = XLSX.utils.table_to_book($table, { raw: true });
          const wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array",
          });
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            subName + ".xlsx"
          );
        } catch (e) {
          console.log(e)
          this.$message.error("导出失败！");
        }
      },
    }
};
export default publicFun;
